import { createPortal } from "react-dom";
import Spinner from "./Spinner";
import { useBoundStore } from "e3-common/store/useBoundStore";

/**
 * 전역 Spinner
 * useLoadingIndicator 훅을 이용해 제어
 */
const E3Spinner = () => {
  const spinnerRoot = document.getElementById("spinner");
  // const { loading } = useLoadIndicatorStore();
  const loading = useBoundStore((state) => state.loadingIndicator.loading);

  return createPortal(loading ? <Spinner /> : null, spinnerRoot);
};

E3Spinner.displayName = "E3Spinner";
export default E3Spinner;
